import React, { Suspense } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import AdminTrialCart from "@atlassiansox/admin-trial-cart";

import { GlobalNavUserProfile } from "@/components/global-nav/user-profile-new/src";
import WplButton from "@/components/wpl/button/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { useLoggedInUser } from "../../../utils/logged-in-user-provider";

import SearchButton from "./search-button";

export type SearchAndProfileProps = {
    isShowTryNowLink?: boolean;
    productKey?: ProductKeyTypes;
    isShowSearchButton?: boolean;
    setIsOpenSearch: React.Dispatch<React.SetStateAction<boolean>>;
};

const tryNowCss = css({
    a: {
        fontWeight: 500,
        borderRadius: "25px 25px 25px 25px"
    }
});

const WacAppSwitcher = React.lazy(() =>
    // without the line ts-ignored below TSC throws this error:
    // "Relative import paths need explicit file extensions in EcmaScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Did you mean '../../../components/global-nav/app-switcher/src/index.js'?"
    // the file of course ends in .tsx, when you try to add that there is a different error:
    // "An import path can only end with a '.tsx' extension when 'allowImportingTsExtensions' is enabled."

    // @ts-ignore
    import("../../../components/global-nav/app-switcher/src/index").then(
        (module) => ({
            default: module.WacAppSwitcher
        })
    )
);

const SearchAndProfile = ({
    isShowTryNowLink = false,
    productKey = "home",
    isShowSearchButton = true,
    setIsOpenSearch
}: SearchAndProfileProps) => {
    const intl = useIntl();
    /* TODO: Implement setIsUserLoggedIn, user logged in status (in useEffect), once GWP-51 in implemented  */
    const { isUserLoggedIn } = useLoggedInUser();
    return (
        <>
            <div className="navigation-trynow" css={tryNowCss}>
                {isShowTryNowLink && (
                    <WplButton
                        text={intl.formatMessage({
                            id: "globalnav.v2.try-now-button-label",
                            defaultMessage: "Try Now"
                        })}
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        url={useLocalizedHref("/try")}
                        size="small"
                        dataEventProps={{
                            "data-product-key": productKey,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "navbar"
                        }}
                    />
                )}
            </div>
            <div className="navigation-search">
                {isShowSearchButton && (
                    <SearchButton
                        onClick={(e) => {
                            e.preventDefault();
                            setIsOpenSearch(true);
                        }}
                    />
                )}
            </div>
            <ul className="navigation-action">
                <li>
                    <div className="navigation-switcher-divider" />
                    {isUserLoggedIn && (
                        <Suspense>
                            <WacAppSwitcher
                                allowJoinSitesProvider={true}
                                appSwitcherLabel={intl.formatMessage({
                                    id: "globalnav.v2.app-switcher-my-products",
                                    defaultMessage: "My products"
                                })}
                            />
                        </Suspense>
                    )}
                </li>
                <li>
                    <GlobalNavUserProfile />
                </li>
                <li className="navigation-cart-button">
                    <AdminTrialCart version={0} fields={{}} />
                </li>
            </ul>
        </>
    );
};

export default SearchAndProfile;
